import { ReactNode } from "react";

interface MarqueeProps {
  items: string[];
  separator?: ReactNode;
  speedSec?: number;
  reverse?: boolean;
  className?: string;
}

/**
 * Editorial typographic marquee — a single horizontal line of
 * uppercase labels separated by a hairline ornament, scrolling
 * continuously. Pauses on hover.
 */
export default function Marquee({
  items,
  separator,
  speedSec = 42,
  reverse = false,
  className = "",
}: MarqueeProps) {
  const sep = separator ?? (
    <span className="mx-6 md:mx-10 inline-flex items-center text-white/55">
      <span className="w-1.5 h-1.5 flex items-center justify-center rounded-full bg-white/70" />
    </span>
  );

  const Row = (
    <div className="flex items-center shrink-0 whitespace-nowrap">
      {items.map((it, i) => (
        <span key={`${it}-${i}`} className="inline-flex items-center">
          <span className="font-label text-[12px] md:text-[13px] tracking-[0.32em] text-white/80">
            {it}
          </span>
          {sep}
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`lum-marquee-pause relative overflow-hidden ${className}`}
      style={
        {
          // soft edge fade
          maskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
        } as React.CSSProperties
      }
    >
      <div
        className="lum-marquee"
        style={{
          animationDuration: `${speedSec}s`,
          animationDirection: reverse ? "reverse" : "normal",
        }}
      >
        {Row}
        {Row}
      </div>
    </div>
  );
}